import { getRequest, postRequest } from ".";

export const avatarPresignedUrl = (file) => {
    return postRequest('/avatar/presigned-url', file);
};

export const addAvatarData = (data) => {
    return postRequest(`/avatar/avatar-image`, data);
}

export const getAllAvatarImages = () => {
    return getRequest('/avatar/get-all');
}

export const getUserBots = () => {
    return getRequest('/avatar/get-user-bots');
}